import { embedHsForm } from '../lib/hsForms';

export function initBlockLeadForm(parent) {
  if (!parent) return;
}

export function initBlockLeadForms() {
  const blocks = document.querySelectorAll('.block-lead-form');
  blocks.forEach((block) => initBlockLeadForm(block));
}
